import React from "react";
import { AllocationType } from "../../types/api/allocations";
import i18n from "../../i18n/config";
import { AllocationTableProps } from "../../types/components";

import AllocationTableRow from "./AllocationTableRow";

const AllocationTable = ({ isAvailableTableType, allocations = [], showStatusCol, isIndexPage = false, handleInfoTipModal }: AllocationTableProps) => {
  /**
   * Calculate total fees
   */
  const getTotalFees = () => {
    if (!allocations || allocations.length === 0) {
      return 0;
    }
    return allocations.reduce((acc, allocation) => {
      if (allocation.fixed > 0 || allocation.percentage > 0 || allocation.getsRemainder) {
        if (allocation.selected || allocation.selectedForFreeTransfer) {
          return acc;
        }

        return acc + allocation.wireFee;
      }
      return acc;
    }, 0).toLocaleString(navigator.language, { style: "currency", currency: allocations[0].productCurrency.code });
  }

  /**
   * Check if any allocation gets remainder, if so, don't show 100% in total row
   */
  const hasGetsRemainder = allocations.some(allocation => allocation.getsRemainder);

  /**
   * Sort allocations based on if active, if card, or neither
   * Only sort if available table type and index page
   * Strange sort behavior in Chrome on AllocationConfirmation page when submitting, it resorts on submit. 
   */
  if (isAvailableTableType && isIndexPage) {
    allocations.sort((a, b) => {
      // if allocation is allocated to, it should be at top
      // then if allocation is card, it should be next
      if (a.fixed > 0 || a.percentage > 0 || a.getsRemainder) {
        return -1;
      } else if (a.cardNumberLastFour) {
        if (b.fixed > 0 || b.percentage > 0 || b.getsRemainder) {
          return 1;
        } else {
          return -1;
        }
      } else {
        return 1;
      }
    });
  }

  return (
    <section className="overflow-scroll width-100">
      <table className={`bwp-table ${isAvailableTableType ? "available" : "unavailable"}`}>
        <thead>
          <tr>
            <th>{i18n.t("PAGES.ALLOCATIONS.INDEX.TABLE.COL_HEADING_1")}</th>
            <th>{i18n.t("PAGES.ALLOCATIONS.INDEX.TABLE.COL_HEADING_2")}</th>
            <th>{i18n.t("PAGES.ALLOCATIONS.INDEX.TABLE.COL_HEADING_3")}</th>
            <th>{isAvailableTableType ? i18n.t("PAGES.ALLOCATIONS.INDEX.TABLE.COL_HEADING_4") : ""}</th>
            {showStatusCol && <th>{i18n.t("PAGES.ALLOCATIONS.INDEX.TABLE.COL_HEADING_5")}</th>}
            <th>{isAvailableTableType ? i18n.t("PAGES.ALLOCATIONS.INDEX.TABLE.COL_HEADING_6") : ""}</th>
          </tr>
        </thead>

        <tbody>
          {allocations.length > 0 ? (
            allocations.map((allocation: AllocationType) => (
              <AllocationTableRow
                key={allocation.id}
                allocation={allocation}
                showStatusCol={showStatusCol}
                isIndexPage={isIndexPage}
                handleInfoTipModal={handleInfoTipModal}
              />
            ))
          ) : (
            <tr>
              <td colSpan={5} className="text-left">{i18n.t("PAGES.ALLOCATIONS.INDEX.TABLE.NO_ALLOCATIONS_FOUND")}</td>
            </tr>
          )}
        </tbody>

        {isAvailableTableType && allocations.length > 0 &&
          <tfoot>
            <tr>
              <td>{i18n.t("COMMON.TOTAL")}: </td>
              <td></td>
              <td></td>
              <td className="bwp-table__numeric">{getTotalFees()}*</td>
              {showStatusCol && <td></td>}
              <td className="bwp-table__numeric">{!hasGetsRemainder ? i18n.t("COMMON.100_PERCENT") : ""}</td>
            </tr>
          </tfoot>
        }
      </table>
    </section>
  );
}

export default AllocationTable;